import Konva from '../../../konva';

export const SNAP_GUIDES_GROUP_ID = 'snap-guides-overlay';

const GUIDE_STROKE = '#ff4081';
const GUIDE_DASH = [4, 4];

export const serializeSnapGuides = (guides = {}) => {
  const vertical = guides.vertical ?? [];
  const horizontal = guides.horizontal ?? [];
  return `${vertical.join(',')}|${horizontal.join(',')}`;
};

export const clearSnapGuidesOverlay = (designLayer) => {
  if (!designLayer?.findOne) {
    return;
  }
  designLayer.findOne(`#${SNAP_GUIDES_GROUP_ID}`)?.destroy();
};

export const drawSnapGuidesOverlay = (designLayer, guides = {}) => {
  if (!designLayer?.findOne) {
    return;
  }

  const vertical = guides.vertical ?? [];
  const horizontal = guides.horizontal ?? [];
  const guidesKey = serializeSnapGuides(guides);

  if (vertical.length === 0 && horizontal.length === 0) {
    clearSnapGuidesOverlay(designLayer);
    return guidesKey;
  }

  const existing = designLayer.findOne(`#${SNAP_GUIDES_GROUP_ID}`);
  if (existing?.getAttr('guidesKey') === guidesKey) {
    return guidesKey;
  }

  clearSnapGuidesOverlay(designLayer);

  const {
    clipX = 0,
    clipY = 0,
    clipWidth = 0,
    clipHeight = 0,
  } = designLayer.attrs ?? {};

  if (!clipWidth || !clipHeight) {
    return guidesKey;
  }

  const group = new Konva.Group({
    id: SNAP_GUIDES_GROUP_ID,
    listening: false,
    guidesKey,
  });

  vertical.forEach((x) => {
    group.add(
      new Konva.Line({
        points: [x, clipY, x, clipY + clipHeight],
        stroke: GUIDE_STROKE,
        strokeWidth: 1,
        dash: GUIDE_DASH,
        listening: false,
      }),
    );
  });

  horizontal.forEach((y) => {
    group.add(
      new Konva.Line({
        points: [clipX, y, clipX + clipWidth, y],
        stroke: GUIDE_STROKE,
        strokeWidth: 1,
        dash: GUIDE_DASH,
        listening: false,
      }),
    );
  });

  designLayer.add(group);
  group.moveToTop();
  designLayer.batchDraw();

  return guidesKey;
};
